/* eslint-disable import/no-anonymous-default-export */
export default (investment = [], action) => {
  switch (action.type) {
    case "GET_ALL_INVESTMENTS":
      return action.payload;
    case "CREATE_INVESTMENT":
      return [...investment, action.payload];
    case "APPROVE_INVESTMENT":
      return investment.filter((data) => data._id !== action.payload);
    case "DELETE_INVESTMENT":
      return investment.filter((data) => data._id !== action.payload);
    default:
      return investment;
  }
};
